import React, { useState } from "react"

import { Row, Col } from "react-bootstrap"

import { TRAINING_FORM_SUBMIT } from "../actions/educationAction"

import Edit from "../../../images/icons/wdn-edit.png"
import Wrong from "../../../images/icons/wdn-wrong.png"
import Warning from "../../../images/icons/wdn-warning.png"

import TextArea from "../../input/textarea"
import InputTextBox from "../../input/input-text-box"

const TrainingInputForm = props => {
  const {
    trainingFormData,
    setTrainingFormData,
    uploadedImage,
    setUploadedImage,
    setAddTraining,
  } = props

  const [error, setError] = useState({})
  const [image_field, setImageField] = useState()

  const handleTitleFieldChange = e => {
    setTrainingFormData({ ...trainingFormData, title: e })
  }

  // const handleUrlFieldChange = e => {
  //   setTrainingFormData({ ...trainingFormData, url: e })
  // }

  const handleDescriptionFieldChange = e => {
    setTrainingFormData({ ...trainingFormData, description: e.target.value })
  }

  const handleFileUpload = e => {
    handleOnFocus()
    setUploadedImage(URL.createObjectURL(e.target.files[0]))
    setImageField(e.target.files[0])
  }

  const handleImageRemove = e => {
    setUploadedImage()
    setImageField()
    setTrainingFormData({ ...trainingFormData, imageUrl: "" })
  }

  const [isLoading, setIsLoading] = useState(false)

  const handleOnFocus = () => {
    setError({})
  }

  const handleTrainingFormSubmit = e => {
    setIsLoading(true)
    e.preventDefault()
    try {
      const id = JSON.parse(localStorage.getItem("user")).id
      TRAINING_FORM_SUBMIT(
        trainingFormData,
        setError,
        id,
        setAddTraining,
        image_field,
        setIsLoading
      )
    } catch (err) {}
  }

  return (
    <>
      <h1>Add Training</h1>
      <form onSubmit={handleTrainingFormSubmit}>
        <Row>
          <Col className="mb-4 ">
            <div className={`modal-images__wrapper ${error.image && "error"}`}>
              <div className="buttons hide-buttons d-flex align-items-center justify-content-center">
                <label
                  onChange={handleFileUpload}
                  htmlFor="portfolio-image"
                  className="cross"
                >
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a aria-hidden="true">
                    <img src={Edit} alt="wdn-edit" />
                  </a>
                  <input
                    type="file"
                    hidden
                    accept="image/x-png,image/jpeg"
                    id="portfolio-image"
                    onChange={handleFileUpload}
                  />
                </label>
                <div className="cross">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a aria-hidden="true" onClick={handleImageRemove}>
                    <img src={Wrong} alt="wdn-cross" />
                  </a>
                </div>
              </div>
              {(trainingFormData.imageUrl || uploadedImage) && (
                <img
                  className="portfolio-image"
                  alt=""
                  src={uploadedImage || trainingFormData.imageUrl}
                />
              )}
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <InputTextBox
              onFocus={handleOnFocus}
              value={trainingFormData.title}
              label="Training Title*"
              class={error.title && "error"}
              onChange={handleTitleFieldChange}
              placeholder="Training Title"
            />
          </Col>
        </Row>
        {/* <Row>
          <Col>
            <InputTextBox
              value={trainingFormData.url}
              label="Training Url"
              class={error.url && "error"}
              onFocus={handleOnFocus}
              onChange={handleUrlFieldChange}
              placeholder="Training URL"
            />
          </Col>
        </Row> */}
        <Row>
          <Col>
            <TextArea
              onFocus={handleOnFocus}
              value={trainingFormData.description}
              class={error.description && "error"}
              label="Training Description*"
              onChange={handleDescriptionFieldChange}
              placeholder="Describe about the Training"
            />
          </Col>
        </Row>
        {error &&
          Object.keys(error)
            .slice(0, 1)
            .map((key, value) => {
              return (
                <div
                  key={value}
                  className="alert-block mb-4 d-flex align-items-center"
                >
                  <img src={Warning} className="mr-3" alt="wdn-warning" />
                  {error[key]}
                </div>
              )
            })}
        <Row>
          <Col>
            <button
              type="submit"
              className="btn w-100 btn-custom rounded primary"
              disabled={isLoading}
            >
              {isLoading ? "Processing" : "Save"}
            </button>
          </Col>
        </Row>
      </form>
    </>
  )
}

export default TrainingInputForm
